import script from "./radar.vue?vue&type=script&setup=true&lang=ts"
export * from "./radar.vue?vue&type=script&setup=true&lang=ts"

import "./radar.vue?vue&type=style&index=0&id=32572966&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32572966"]])

export default __exports__